import { SVGProps } from 'react';

const BouncingTyping = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="currentColor" viewBox="0 0 256 256" {...props}>
        <style>
            {
                '@keyframes bt-bounce{0%,60%,to{transform:translateY(0)}30%{transform:translateY(-14px)}}.bt-dot{animation:bt-bounce 1.2s ease-in-out infinite;transform-box:fill-box;transform-origin:center}.bt-dot:nth-of-type(2){animation-delay:.15s}.bt-dot:nth-of-type(3){animation-delay:.3s}'
            }
        </style>
        <circle className="bt-dot" cx={48} cy={128} r={28} />
        <circle className="bt-dot" cx={128} cy={128} r={28} />
        <circle className="bt-dot" cx={208} cy={128} r={28} />
    </svg>
);

export default BouncingTyping;
